/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebPublicConfiguration } from '../shiva-web-public-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getStation } from '../fn/station/get-station';
import { GetStation$Params } from '../fn/station/get-station';
import { Station } from '../models/station';

@Injectable({ providedIn: 'root' })
export class StationService extends BaseService {
  constructor(config: ShivaWebPublicConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStation()` */
  static readonly GetStationPath = '/stations/{uid}';

  /**
   * Retrieve a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStation$Response(params: GetStation$Params, context?: HttpContext): Observable<StrictHttpResponse<Station>> {
    return getStation(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStation(params: GetStation$Params, context?: HttpContext): Observable<Station> {
    return this.getStation$Response(params, context).pipe(
      map((r: StrictHttpResponse<Station>): Station => r.body)
    );
  }

}
